export type ErudaUrlMatcher = string | RegExp | ((url: URL) => boolean)

/**
 * Añade aquí las URLs (o patrones) donde quieres que Eruda se active.
 *
 * Ejemplos:
 * - "/login" (path)
 * - "https://app.tudominio.com/admin"
 * - /localhost:\d+\/public-views/
 * - (url) => url.hostname === "staging.tudominio.com"
 */
export const ERUDA_ALLOWED_URLS: ErudaUrlMatcher[] = [
  'https://app.teaminglabs.com/player_view/7f7e9ac6-4f9c-4d0f-9766-19ab597256d9/312872cb-7d69-41cd-8a9e-c805935a4382',
  'https://app.teaminglabs.com/player_view/7f7e9ac6-4f9c-4d0f-9766-19ab597256d9/8d78ad8a-692a-4b66-84ad-0fb23dc551df',
  'https://app.teaminglabs.com/player_view/d2b63369-b003-427b-bcb5-02f2c048fe91/3db31189-c8aa-4dc6-b72b-aa95fea1f261'

]

